import styles from './table-cell-list.module.css';

interface TableCellListProps<T> {
  items: T[];
  getItem?: (item: T) => string;
}

export const TableCellList = <T,>({
  items,
  getItem = (item: T) => String(item),
}: TableCellListProps<T>) => {
  return (
    <ul>
      {items.map((t, index) => (
        <li key={index} className={styles['table-cell-list-item']}>
          {getItem(t)}
          {index === items.length - 1 ? '' : ','}
        </li>
      ))}
    </ul>
  );
};
